const SAVE = "SAVE_BRANDS";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}